






















import { defineComponent, ref, computed, watch } from '@nuxtjs/composition-api';
import { usePDPExtras } from '@vue-storefront/novulo';

export default defineComponent({
  name: 'AvailabilityDrawer',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    stockClassificationCode: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const { getPDPDeliveryContainer } = usePDPExtras();

    const isLoading = ref(false);
    const error = ref(false);
    const deliveryContainer = ref(null);

    const hasAlreadyLoadedDeliveryContainer = ref(false);

    const fetchDeliveryContainer = async () => {
      isLoading.value = true;
      try {
        const response = await getPDPDeliveryContainer(
          props.stockClassificationCode
        );
        deliveryContainer.value = response?.[0]?.elements?.[0] ?? null;
      } catch (e) {
        error.value = true;
      }
      isLoading.value = false;
    };

    watch(
      () => props.isOpen,
      async (newValue) => {
        if (newValue && !hasAlreadyLoadedDeliveryContainer.value) {
          await fetchDeliveryContainer();
          hasAlreadyLoadedDeliveryContainer.value = true;
        }
      }
    );

    const drawerData = computed(() => {
      const drawerContent = deliveryContainer.value?.urls?.[0] || null;

      if (!drawerContent) return null;

      return {
        content: drawerContent.html,
        cta: {
          link: drawerContent.url,
          text: drawerContent.title
        }
      };
    });

    const shouldShowCta = computed(() => {
      if (isLoading.value || error.value || !drawerData.value) {
        return false;
      }

      return drawerData.value?.cta?.link && drawerData.value?.cta?.text;
    });

    const handleCtaClick = () => {
      if (!drawerData.value?.cta?.link) return;

      window.open(drawerData.value.cta.link, '_blank');
    };

    return {
      isLoading,
      error,
      drawerData,
      shouldShowCta,
      handleCtaClick
    };
  }
});
